import React, { useState } from 'react';
import './TestimonialsSlider.scss'


function TestimonialsSlider({ slides }) {
    const [activeSlide, setActiveSlide] = useState(1);

    const handleSlideChange = (newSlide) => {
        const textElement = document.querySelector('.text');
        textElement.classList.remove('fade-in');
        textElement.classList.add('fade-out');
    
        const imgElement = document.querySelector('.left-div img');
        imgElement.style.transform = 'scale(0.8)';
    
        setTimeout(() => {
            setActiveSlide(newSlide);
            textElement.classList.remove('fade-out');
            textElement.classList.add('fade-in');
            imgElement.style.transform = 'scale(1)';
        }, 500); // Adjust the delay to match the animation duration
    };
    
    return (
        <div className="slider-container">
            <div className="left-div">
                <img
                    src={slides[activeSlide - 1].imgSrc}
                    alt="Slide"
                    style={{ transition: 'transform 0.5s ease-in-out' }}
                />
            </div>
            <div className="center-div">
                <div className="controls">
                    {slides.map((_, index) => (
                        <div
                            key={index}
                            className={`control ${index + 1 === activeSlide ? 'active' : ''}`}
                            onClick={() => handleSlideChange(index + 1)}
                        >
                            {index + 1}
                        </div>
                    ))}
                </div>
                <div
                    className="text"
                    style={{ transition: 'opacity 0.5s ease-in-out' }}
                >
                    <h5>{slides[activeSlide - 1].text}</h5>
                    <p>{slides[activeSlide - 1].para}</p>
                </div>
            </div>
        </div>
    );
}

export default TestimonialsSlider;
